import { Component } from '@nicolas-riciotti/light2'
import Utils from '../../helpers/Utilities'
import Tween from './Tween';

function getPosition(node, scope) {
    const root = scope || document;
    const width = node.clientWidth;
    const height = node.clientHeight;
    let offsetTop = node.offsetTop;
    let offsetLeft = node.offsetLeft;

    while (
        node &&
        node.offsetParent &&
        node.offsetParent != document &&
        node !== root &&
        root !== node.offsetParent
    ) {
        offsetTop += node.offsetParent.offsetTop;
        offsetLeft += node.offsetParent.offsetLeft;
        node = node.offsetParent;
    }

    return {
        top: offsetTop,
        left: offsetLeft,
        width,
        height
    };
}



export default class CoreDrag extends Component {

    created() {

        this.el = this;
        this.el.style.display = 'block';

    }

    attached() {

        this.data = {
            debug: false,
            offset: 0,
            active: true,
            autoplayPosition: 0,
            content: null,
            currentIndex: 0,
            scroll: 0,
            position: [0, 0],
            cursor: [0, 0],
            prevent: false,
            direction: 'x',
            handlerPosition: [0, 0],
            showBar: false,
            swipe: false,
            desktopOnly: false,

            useDepth: this.el.getAttribute('use-depth') == 'false'
                ? false
                : this.el.hasAttribute('use-depth')
                    ? true
                    : false,

            loop: this.el.getAttribute('loop') == 'false'
                ? false
                : this.el.hasAttribute('loop')
                    ? true
                    : false,

            autoplay: this.el.getAttribute('autoplay') == 'false'
                ? false
                : this.el.hasAttribute('autoplay')
                    ? true
                    : false,

            snapCenter: this.el.getAttribute('snap-center') == 'false'
                ? false
                : this.el.hasAttribute('snap-center') || this.el.hasAttribute('data-snap-center')
                    ? true
                    : false,
        };

        this._snapTarget = null;
        this._snapTween = null;
        this._lastUserScrollTime = 0;
        this._userHasInteracted = false;

        this.snapDuration = this.el.hasAttribute('data-snap-duration')
            ? Number(this.el.getAttribute('data-snap-duration'))
            : 0.95;

        this.snapEasing = [0.43, 0.195, 0.02, 1];

        this.lastDate = this.lastDate || performance.now();
        this.speed = 0;
        this.speedX = 0;
        this._steps = [];

        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);

        this._onPointerDown = this._onPointerDown.bind(this);
        this._onPointerMove = this._onPointerMove.bind(this);
        this._onPointerUp = this._onPointerUp.bind(this);
        this.toggleAutoPlay = this.toggleAutoPlay.bind(this);
        this.toggleAutoPlayPrevent = this.toggleAutoPlayPrevent.bind(this);
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
        this._onWheel = this._onWheel.bind(this);


        this.offset = 0;
        this.isPointerDown = false;
        this._pointerDown = [0, 0];
        this._pointer = [0, 0];
        this._handlerPosition = [0, 0];
        this._positionDown = [0, 0];
        this._position = [0, 0];
        this._dragPosition = [0, 0];
        this._cursor = [0, 0];
        this._accX = 0;
        this._accY = 0;
        this._direction = 1;
        this._loopCloneSignature = '';
        this._isRebuildingLoopClones = false;

        this.$content = this.el.querySelector('[drag-content], [data-drag-content]');

        if (!this.$content) {
            return;
        }

        this._setupLoopClones();

        this.$layers = this.el.querySelectorAll('[drag-layer]');

        this.el.addEventListener('mousedown', this._onPointerDown, { passive: false });
        this.el.addEventListener('touchstart', this._onPointerDown, { passive: false });
        this.el.addEventListener('wheel', this._onWheel, { passive: false });

        document.addEventListener('mousemove', this._onPointerMove, { passive: false });
        document.addEventListener('touchmove', this._onPointerMove, { passive: false });
        document.addEventListener('mouseup', this._onPointerUp, { passive: false });
        document.addEventListener('touchend', this._onPointerUp, { passive: false });


        const resizeObserver = new ResizeObserver(() => {
            this.resize();
        });

        resizeObserver.observe(this.$content);

        this.$content.style.overflowX = 'visible';
        this.$content.style.overflow = 'visible';
        this.$content.style.userSelect = 'none';

        this.el.style.overflow = 'visible';

        if (this.data.useDepth) {
            this.$content.style.transformStyle = 'flat';
        }

        if (this.data.active) {
            this.$content.style.cursor = 'grab';
        }

        this.$nextBtn = this.el.querySelectorAll('[data-drag-next], [drag-next]');
        this.$nextBtn.forEach(el => {
            el.removeEventListener('click', this.next);
            el.addEventListener('click', this.next);
        });

        this.$prevBtn = this.el.querySelectorAll('[data-drag-prev], [drag-prev]');
        this.$prevBtn.forEach(el => {
            el.removeEventListener('click', this.prev);
            el.addEventListener('click', this.prev);
        });

        this.$playBtn = this.el.querySelectorAll('[data-drag-playpause], [drag-playpause]');
        this.$playBtn.forEach(el => {
            el.removeEventListener('mousedown', this.toggleAutoPlayPrevent);
            el.addEventListener('mousedown', this.toggleAutoPlayPrevent);
        });

        this.$playBtn.forEach(el => {
            el.removeEventListener('click', this.toggleAutoPlay);
            el.addEventListener('click', this.toggleAutoPlay);
        });

        this.$scrollbarHandle = this.el.querySelector('[data-drag-scrollbar-handle]');

        this.resize();

        setTimeout(() => {
            this.resize();
        }, 1000);

        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);

        this.stopped = localStorage['accessibility'] === 'true';
    }


    _onWheel(event) {
        if (!this.data.active) return;
        if (this.data.direction !== 'x') return;

        let deltaX = event.deltaX;
        let deltaY = event.deltaY;

        // Normalize wheel units across browsers.
        // 0 = pixels, 1 = lines, 2 = pages.
        if (event.deltaMode === 1) {
            deltaX *= 16;
            deltaY *= 16;
        } else if (event.deltaMode === 2) {
            deltaX *= window.innerWidth;
            deltaY *= window.innerHeight;
        }

        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        // Only handle intentional horizontal scrolling.
        // Vertical page scroll remains untouched.
        if (absX <= absY || absX < 1) {
            return;
        }

        const bounds = this._getPositionBounds();

        const isAtStart = this._position[0] >= bounds.max;
        const isAtEnd = this._position[0] <= bounds.min;

        if (!this.data.loop) {
            if ((deltaX < 0 && isAtStart) || (deltaX > 0 && isAtEnd)) {
                return;
            }
        }

        event.preventDefault();
        event.stopPropagation();

        this._cancelSnap();
        this._lastUserScrollTime = performance.now();

        this._scrollTween && this._scrollTween?.destroy();

        this.data.autoplay = false;
        this.el.classList.add('is-paused');

        this.isPointerDown = false;
        this.isDeccelerating = true;

        /**
         * Important:
         * Wheel delta is not the same as drag pixels.
         * This multiplier makes trackpad scroll feel closer to touch drag.
         */
        const wheelDragRatio = 0.28;

        /**
         * Cap each wheel frame so high-resolution trackpads,
         * Safari momentum, and mouse wheels do not jump too far.
         */
        const maxFrameDelta = 42;

        let dragDelta = deltaX * wheelDragRatio;

        dragDelta = Math.max(
            -maxFrameDelta,
            Math.min(maxFrameDelta, dragDelta)
        );

        // Same direction logic as drag:
        // horizontal wheel right should move content left.
        this._position[0] -= dragDelta;
        this._position[0] = this._clampPositionX(this._position[0]);

        /**
         * Add only a small momentum tail.
         * Your update loop already multiplies speedX by 0.96,
         * so this should stay subtle.
         */
        this.speedX += -dragDelta * 0.025;
        this.speedX = Math.min(3, Math.max(-3, this.speedX));
    }

    
    _setupLoopClones() {
        if (!this.$content) return;
        if (!this.data.loop) return;

        this.$content.querySelectorAll('[data-drag-clone="true"]').forEach(el => {
            el.remove();
        });

        const originals = Array.from(
            this.$content.querySelectorAll('[drag-layer]:not([data-drag-clone])')
        );

        if (!originals.length) return;

        originals.forEach((original, index) => {
            original.setAttribute('data-drag-original-index', index);
            original.setAttribute('data-drag-copy-index', 0);
        });

        const viewportWidth = this.el.clientWidth || window.innerWidth;

        /**
         * Because you use depth/scale/blur, keep this generous.
         * 2 means: clone enough cards to cover 2x the visible width
         * on each side.
         */
        const bufferMultiplier = this.el.hasAttribute('data-loop-buffer')
            ? Number(this.el.getAttribute('data-loop-buffer'))
            : 2;

        const requiredWidth = viewportWidth * bufferMultiplier;
        let createdBefore = 0;
        let createdAfter = 0;

        const cloneLayer = (original, originalIndex, copyIndex) => {
            const clone = original.cloneNode(true);

            clone.setAttribute('data-drag-clone', 'true');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-drag-original-index', originalIndex);
            clone.setAttribute('data-drag-copy-index', copyIndex);

            clone.removeAttribute('id');
            clone.removeAttribute('drag-step');
            clone.removeAttribute('data-drag-step');

            clone.querySelectorAll('[id]').forEach(el => {
                el.removeAttribute('id');
            });

            clone.querySelectorAll('[drag-step], [data-drag-step]').forEach(el => {
                el.removeAttribute('drag-step');
                el.removeAttribute('data-drag-step');
            });

            original.parentNode.appendChild(clone);
        };

        /**
         * Clone enough cards AFTER the original list.
         *
         * This can go:
         * copyIndex 1, 1, 1...
         * then 2, 2, 2...
         * then 3, 3, 3...
         *
         * Only as much as needed.
         */
        let afterWidth = 0;
        let afterCount = 0;

        while (afterWidth < requiredWidth) {
            const originalIndex = afterCount % originals.length;
            const copyIndex = Math.floor(afterCount / originals.length) + 1;
            const original = originals[originalIndex];

            cloneLayer(original, originalIndex, copyIndex);

            afterWidth += original.clientWidth;
            afterCount++;

            createdAfter++;
            /**
             * Safety guard.
             * Prevent infinite cloning if something measures as 0 width.
             */
            if (afterCount > originals.length * 10) {
                break;
            }
        }

        /**
         * Clone enough cards BEFORE the original list.
         *
         * This can go:
         * copyIndex -1, -1, -1...
         * then -2, -2, -2...
         * then -3, -3, -3...
         *
         * Only as much as needed.
         */
        let beforeWidth = 0;
        let beforeCount = 0;

        while (beforeWidth < requiredWidth) {
            const reverseIndex =
                originals.length - 1 - (beforeCount % originals.length);

            const copyIndex =
                -(Math.floor(beforeCount / originals.length) + 1);

            const original = originals[reverseIndex];

            cloneLayer(original, reverseIndex, copyIndex);

            beforeWidth += original.clientWidth;
            beforeCount++;
            createdBefore++;

            /**
             * Safety guard.
             * Prevent infinite cloning if something measures as 0 width.
             */
            if (beforeCount > originals.length * 10) {
                break;
            }
        }

        this._loopCloneSignature = [
            originals.length,
            Math.round(viewportWidth),
            bufferMultiplier,
            createdBefore,
            createdAfter
        ].join(':');

    }


    _rebuildLoopClonesIfNeeded() {
        if (!this.$content) return;
        if (!this.data.loop) return;
        if (this._isRebuildingLoopClones) return;

        const originals = Array.from(
            this.$content.querySelectorAll('[drag-layer]:not([data-drag-clone])')
        );

        if (!originals.length) return;

        const viewportWidth = this.el.clientWidth || window.innerWidth;

        const bufferMultiplier = this.el.hasAttribute('data-loop-buffer')
            ? Number(this.el.getAttribute('data-loop-buffer'))
            : 2;

        const requiredWidth = viewportWidth * bufferMultiplier;

        let afterWidth = 0;
        let afterCount = 0;

        while (afterWidth < requiredWidth) {
            const original = originals[afterCount % originals.length];

            afterWidth += original.clientWidth;
            afterCount++;

            if (afterCount > originals.length * 10) {
                break;
            }
        }

        let beforeWidth = 0;
        let beforeCount = 0;

        while (beforeWidth < requiredWidth) {
            const reverseIndex =
                originals.length - 1 - (beforeCount % originals.length);

            const original = originals[reverseIndex];

            beforeWidth += original.clientWidth;
            beforeCount++;

            if (beforeCount > originals.length * 10) {
                break;
            }
        }

        const nextSignature = [
            originals.length,
            Math.round(viewportWidth),
            bufferMultiplier,
            beforeCount,
            afterCount
        ].join(':');

        if (nextSignature === this._loopCloneSignature) {
            return;
        }

        this._isRebuildingLoopClones = true;

        this._setupLoopClones();

        this._isRebuildingLoopClones = false;
    }

    siteSettingsMotionChange(event) {
        this.stopped = 'off' === event.detail;
        console.log('SITE MOTION CHNAGE', this.stopped);
    }

   
    prev() {
        if (!this._steps.length) return;
        const bounds = this._getPositionBounds();
        const current = this._position[0];
        const epsilon = 2;
        let target = bounds.max;
        for (let i = this._steps.length - 1; i >= 0; i--) {
            const stepTarget = this._left - this._steps[i].left;
            if (stepTarget > current + epsilon) {
                target = stepTarget;
                break;
            }
        }
        target = Math.min(bounds.max, Math.max(bounds.min, target));
        this._scrollTween && this._scrollTween?.destroy();
        this.speedX = 0;
        this.isDeccelerating = false;
        this.isPointerDown = false;
        const distance = Math.abs(target - current);
        const base = this._steps[0].width || 1;
        this._scrollTween = Tween(this._position, {
            to: { 0: target },
            duration: 1.3,//Math.max(0.35, 1.3 * Math.min(1, distance / base)),
            easing: [0.43, 0.195, 0.02, 1],
        });
    }

    next() {
        if (!this._steps.length) return;
        const bounds = this._getPositionBounds();
        const current = this._position[0];
        const epsilon = 2;
        let target = bounds.min;
        for (let i = 0; i < this._steps.length; i++) {
            const stepTarget = this._left - this._steps[i].left;
            if (stepTarget < current - epsilon) {
                target = stepTarget;
                break;
            }
        }
        target = Math.min(bounds.max, Math.max(bounds.min, target));
        this._scrollTween && this._scrollTween?.destroy();
        this.speedX = 0;
        this.isDeccelerating = false;
        this.isPointerDown = false;
        const distance = Math.abs(target - current);
        const base = this._steps[0].width || 1;
        this._scrollTween = Tween(this._position, {
            to: { 0: target },
            duration: 1.3,//Math.max(0.35, 1.3 * Math.min(1, distance / base)),
            easing: [0.43, 0.195, 0.02, 1],
        });
    }



    
    onCurrentIndexChange() {}

    _onPointerDown(event) {
        this.speedX = 0;
        this.lastDate = performance.now();

        this._cancelSnap();
        this._lastUserScrollTime = performance.now();

        this.isPointerDown = true;
        this.preventClick = false;

        let touchEvent = event.touches || event.changedTouches
            ? event.touches[0] || event.changedTouches[0]
            : event;

        let touchEventPageX = touchEvent.pageX;
        let touchEventPageY = touchEvent.pageY;

        touchEventPageX -= window.pageXOffset || document.documentElement.scrollLeft;
        touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;

        this.lastTouchEventPageX = touchEventPageX;
        this.lastTouchEventPageY = touchEventPageY;

        this._accX = 0;
        this._accY = 0;
        this._mobileAxisLock = null;

        this._pointerDown[0] = touchEventPageX;
        this._pointerDown[1] = touchEventPageY;

        this._positionDown[0] = this._position[0];
        this._positionDown[1] = this._position[1];

        this._lastMoveX = this._pointerDown[0];
        this._lastMoveY = this._pointerDown[1];

        this.isPointerDown = true;

        if (this.data.active) {
            this.$content.style.cursor = 'grabbing';
        }

        this.isDeccelerating = false;
        this.lastDate = performance.now();
    }

    toggleAutoPlayPrevent(e) {
        this.isToggleBtn = true;
        console.log('toggleAutoPlayPrevent');
    }

    toggleAutoPlay(e) {
        this.data.autoplay = !this.data.autoplay;
        this.el.classList[this.data.autoplay ? 'remove' : 'add']('is-paused');

        this.$playBtn.forEach(btn => {
            btn.setAttribute(
                'aria-label',
                this.data.autoplay ? 'Stop auto play' : 'Start auto play'
            );
        });

        console.log('toggleAutoPlay', this.data.autoplay);
    }

    _onHandlerDown() {
        this.isHanlderDown = true;
    }

    _onPointerMove(event) {

        let touchEvent = event.touches || event.changedTouches
            ? event.touches[0] || event.changedTouches[0]
            : event;

        let touchEventPageX = touchEvent.pageX;
        let touchEventPageY = touchEvent.pageY;

        touchEventPageX -= window.pageXOffset || document.documentElement.scrollLeft;
        touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;

        if (!this.isPointerDown) {
            return;
        }

        this.lastTouchEventPageX = this.lastTouchEventPageX || touchEventPageX;
        this.lastTouchEventPageY = this.lastTouchEventPageY || touchEventPageY;

        let diffX = touchEventPageX - this.lastTouchEventPageX;
        let diffY = touchEventPageY - this.lastTouchEventPageY;

        this.lastTouchEventPageX = touchEventPageX;
        this.lastTouchEventPageY = touchEventPageY;

        if (!this.isHanlderDown) {
            this._accX += Math.abs(this._lastMoveX - touchEventPageX);
            this._accY += Math.abs(this._lastMoveY - touchEventPageY);

            this._lastMoveX = touchEventPageX;
            this._lastMoveY = touchEventPageY;


            if (window.innerWidth <= 600) {
                const totalDX = Math.abs(touchEventPageX - this._pointerDown[0]);
                const totalDY = Math.abs(touchEventPageY - this._pointerDown[1]);

                if (this._mobileAxisLock == null && (totalDX > 8 || totalDY > 8)) {
                    this._mobileAxisLock = totalDX > totalDY * 1.2 ? 'x' : 'y';
                }

                if (this._mobileAxisLock !== 'x') {
                    // Not a clear horizontal drag -> treat as page scroll.
                    this.speedX = 0;
                    this.preventClick = false;
                    return;
                }
            }

            if (this.data.direction == 'y') {
                event.preventDefault();
                event.stopPropagation();
            }

            if (
                (Math.abs(this._accX) > 5 &&
                    Math.abs(this._accX) > Math.abs(this._accY) &&
                    this.data.direction == 'x') ||
                (Math.abs(this._accY) > 5 &&
                    Math.abs(this._accY) > Math.abs(this._accX) &&
                    this.data.direction == 'y') ||
                this.preventClick
            ) {
                this.preventClick = true;
                window.preventClick = true;
                this._lastUserScrollTime = performance.now();

                this.lastDate = this.lastDate || performance.now();

                const timeDiff = performance.now() - this.lastDate;

                this.speedX = diffX / (timeDiff + 0.001);
                this.speedX = Math.min(10, Math.max(-10, this.speedX));

                this.lastDate = performance.now();

                this.layers?.forEach(layer => {
                    layer.el.querySelectorAll('a').forEach(a => {
                        a.style.pointerEvents = 'none';
                    });
                });
            }
        }

        if (!event.touches && !event.changedTouches) {
            this.data.autoplay = false;
            this.el.classList[this.data.autoplay ? 'remove' : 'add']('is-paused');
        }
    }

    _onPointerUp(event) {
        this.isHanlderDown = false;

        if (!this.isPointerDown) {
            this.isToggleBtn = false;
            return true;
        }

        if (!event.touches && !event.changedTouches && !this.isToggleBtn) {
            this.data.autoplay = false;
            this.el.classList[this.data.autoplay ? 'remove' : 'add']('is-paused');
        }

        this.isToggleBtn = false;

        if (this.preventClick) {
            event.preventDefault();
            event.stopPropagation();

            setTimeout(() => {
                this.data.prevent = false;
                this.isPointerDown = false;
                this.preventClick = false;

                this.layers?.forEach(layer => {
                    layer.el.querySelectorAll('a').forEach(a => {
                        a.style.pointerEvents = 'auto';
                    });
                });
            }, 200);
        } else {
            this.preventClick = false;
        }

        if (this.data.active) {
            this.$content.style.cursor = 'grab';
        }

        this.isDeccelerating = true;
        this.isPointerDown = false;
        this._userHasInteracted = true;
        this._lastUserScrollTime = performance.now();

        setTimeout(() => {
            requestAnimationFrame(() => {
                window.preventClick = false;
            });
        }, 10);
    }

    _getOriginalLayers() {
        return (this.layers || [])
            .filter(layer => layer.copyIndex === 0 && !layer.isClone)
            .sort((a, b) => a.originalIndex - b.originalIndex);
    }

    _getPositionBounds() {
        if (this.data.loop) {
            return {
                min: -Infinity,
                max: Infinity
            };
        }

        if (
            this.data.snapCenter &&
            this.layers &&
            this.layers.length &&
            this._width > 0
        ) {
            const originalLayers = this._getOriginalLayers();

            if (originalLayers.length) {
                const viewCenter = this._width / 2;
                const first = originalLayers[0];
                const last = originalLayers[originalLayers.length - 1];

                const max = viewCenter - (first.left + first.width / 2);
                const min = viewCenter - (last.left + last.width / 2);

                return {
                    min: Math.min(min, max),
                    max: Math.max(min, max)
                };
            }
        }

        return {
            min: Math.min(0, -this._contentWidth + this._width),
            max: 0
        };
    }

    _clampPositionX(value) {
        if (this.data.loop) return value;

        const bounds = this._getPositionBounds();

        return Math.min(
            bounds.max,
            Math.max(bounds.min, value)
        );
    }

    _cancelSnap() {
        this._snapTween && this._snapTween?.destroy();
        this._snapTween = null;
        this._snapTarget = null;
    }

    _getWrappedPosition(position = this._position[0]) {
        const loopWidth = this._scrollWidth || this._contentWidth || 0;

        if (!this.data.loop || loopWidth <= 0) {
            return position;
        }

        let wrappedPosition = position % loopWidth;

        if (wrappedPosition > 0) {
            wrappedPosition -= loopWidth;
        }

        return wrappedPosition;
    }

    _computeSnapTarget() {
        if (!this.data.snapCenter) return null;
        if (!this.layers || !this.layers.length) return null;
        if (!this._width) return null;

        const viewCenter = this._width / 2;
        const loopWidth = this._scrollWidth || this._contentWidth || 0;
        const wrappedPosition = this._getWrappedPosition(this._position[0]);

        const candidates = this.data.loop
            ? this.layers
            : this._getOriginalLayers();

        if (!candidates.length) return null;

        let nearestLayer = null;
        let minDistance = Infinity;

        candidates.forEach(layer => {
            const baseLeft = this.data.loop ? layer.baseLeft : layer.left;
            const cardCenter = baseLeft + wrappedPosition + layer.width / 2;
            const distance = Math.abs(cardCenter - viewCenter);

            if (distance < minDistance) {
                minDistance = distance;
                nearestLayer = layer;
            }
        });

        if (!nearestLayer) return null;

        const targetBaseLeft = this.data.loop
            ? nearestLayer.baseLeft
            : nearestLayer.left;

        const targetWrappedPosition =
            viewCenter -
            targetBaseLeft -
            nearestLayer.width / 2;

        if (this.data.loop && loopWidth > 0) {
            const loopsPassed = Math.round(
                (this._position[0] - targetWrappedPosition) / loopWidth
            );

            return targetWrappedPosition + loopsPassed * loopWidth;
        }

        return this._clampPositionX(targetWrappedPosition);
    }

    _startSnapToCenter(immediate = false) {
        const target = this._computeSnapTarget();

        if (target === null) {
            this._cancelSnap();
            return;
        }

        this._cancelSnap();

        if (immediate) {
            this._position[0] = target;
            this.data.position[0] = target;
            this.speedX = 0;
            return;
        }

        this._snapTarget = target;
        this.speedX = 0;

        this._snapTween = Tween(this._position, {
            to: {
                0: target,
            },
            duration: this.snapDuration,
            easing: this.snapEasing,
        });
    }

    resize() {

        // if (window.innerWidth <= 600) {
        //     return;
        // }

        if (window.innerWidth <= 600) {
            const now = performance.now();
            if (this._mobileFirstResizeAt == null) this._mobileFirstResizeAt = now;
            const width = this.el.clientWidth;
            const settled = now - this._mobileFirstResizeAt > 1500;
            if (settled && this._mobileLastWidth != null && Math.abs(width - this._mobileLastWidth) < 1) {
                return;
            }
            this._mobileLastWidth = width;
        }

        this._scrollTween && this._scrollTween?.destroy();
        this._cancelSnap();

        if (!this.$content) return;

        this._rebuildLoopClonesIfNeeded();

        this._width = this.el.clientWidth;
        this._height = this.el.clientHeight;

        this._contentWidth =
            this.$content.scrollWidth *
            (this.el.hasAttribute('data-trim')
                ? Number(this.el.getAttribute('data-trim'))
                : 1);

        this._contentHeight = this.$content.scrollHeight;

        let bounds = getPosition(this.el);
        this._left = bounds.left;
        this._top = bounds.top;

        if (this.$content) {
            let contentBounds = getPosition(this.$content);
            this._contentLeft = contentBounds.left;
        }

        this.$layers = this.el.querySelectorAll('[drag-layer]');

        this.layers = [];

        this.$layers.forEach((el, i) => {
            const originalIndex = Number(el.getAttribute('data-drag-original-index') || 0);
            const copyIndex = Number(el.getAttribute('data-drag-copy-index') || 0);

            this.layers.push({
                el,
                x: 0,
                ratio: 0,
                width: el.clientWidth,
                left: getPosition(el).left - this._left,
                measuredLeft: getPosition(el).left - this._left,
                originalIndex,
                copyIndex,
                isClone: el.getAttribute('data-drag-clone') === 'true',
                baseLeft: 0,
            });

            el.style.willChange = 'transform, filter';
            el.style.position = el.style.position || 'relative';
            el.style.transformOrigin = 'center center';
        });

        this.data.position[0] = 0;
        this._position[0] = 0;

        this._steps = [];
        this.el
            .querySelectorAll('[drag-step]:not([data-drag-clone]), [data-drag-step]:not([data-drag-clone])')
            .forEach(el => {
                this._steps.push({
                    el,
                    width: el.clientWidth,
                    left: getPosition(el).left
                });
            });

        for (let i = 0; i < this._steps.length; i++) {
            this._steps[i].width = this._steps[i].el.clientWidth;
            this._steps[i].left = getPosition(this._steps[i].el).left;
        }

        const originalLayers = this.layers
            .filter(layer => layer.copyIndex === 0)
            .sort((a, b) => a.originalIndex - b.originalIndex);

        if (originalLayers.length > 1) {
            const first = originalLayers[0];
            const last = originalLayers[originalLayers.length - 1];
            const beforeLast = originalLayers[originalLayers.length - 2];

            const space =
                last.left -
                (beforeLast.left + beforeLast.width);

            this._scrollWidth =
                last.left +
                last.width +
                space -
                first.left;
        } else {
            this._scrollWidth = this._contentWidth;
        }

        this.layers.forEach(layer => {
            const original = originalLayers[layer.originalIndex];

            if (!original) return;

            layer.width = original.width;
            layer.baseLeft = original.left + layer.copyIndex * this._scrollWidth;
        });

        if (this.data.snapCenter && !this._userHasInteracted) {
            this._startSnapToCenter(true);
        }
    }

    update() {
        
        if (!this.data.active) {
            return;
        }

        if (this.data.active) {
            this.$content.style.cursor = 'grab';
        }

        if (this._steps && this._steps.length > 0) {
            let lastActive = -1;

            if (this._steps.length > 0) {
                let isFirst = this._position[0] > -10;

                this.$prevBtn?.forEach(el => {
                    if (isFirst && !el.classList.contains('is-disabled')) {
                        el.classList.add('is-disabled');
                    }

                    if (!isFirst && el.classList.contains('is-disabled')) {
                        el.classList.remove('is-disabled');
                    }
                });

                let isLast =
                    this._steps[this._steps.length - 1].left +
                    this._steps[this._steps.length - 1].width +
                    this._position[0] <=
                    this._left + this._width;

                this.$nextBtn?.forEach(el => {
                    el.classList[isLast ? 'add' : 'remove']('is-disabled');
                });

                for (let i = 0; i < this._steps.length; i++) {
                    const currPos = this._steps[i].left + this._position[0];

                    if (currPos <= this._left + this._steps[0].width) {
                        lastActive = i;
                    }
                }
            }

            if (lastActive !== this._lastActive) {
                this._lastActive = lastActive;

                let nextIndex =
                    this._lastActive + 1 >= this._steps.length
                        ? 0
                        : this._lastActive + 1;

                let prevIndex =
                    this._lastActive - 1 < 0
                        ? this._steps.length - 1
                        : this._lastActive - 1;

                this.$prevBtn?.forEach(el =>
                    el?.setAttribute(
                        'aria-label',
                        `Scroll view forward to show slide ${prevIndex + 1}`
                    )
                );

                this.$nextBtn?.forEach(el =>
                    el?.setAttribute(
                        'aria-label',
                        `Scroll view backward to show slide ${nextIndex + 1}`
                    )
                );
            }
        }

        if (!this.stopped) {
            this._position[0] += this.speedX * 17;
        }

        this.speedX *= 0.96;

        if (Math.abs(this.speedX) < 0.01) {
            this.isDeccelerating = false;
        }

        if (
            this.data.snapCenter &&
            !this.isPointerDown &&
            !this.data.autoplay &&
            !this.isDeccelerating &&
            !this._snapTween &&
            performance.now() - this._lastUserScrollTime > 140
        ) {
            this._startSnapToCenter(false);
        }

        if (
            this.data.autoplay &&
            !this.isPointerDown &&
            !this.isDeccelerating &&
            !this.stopped
        ) {
            this._position[0] -= 0.4;

            if (!this.data.loop) {
                this._position[0] = Math.min(
                    0,
                    Math.max(-this._contentWidth + this._width, this._position[0])
                );
            }
        }

        if (!this.data.loop) {
            this._position[0] = this._clampPositionX(this._position[0]);

            this._position[1] = Math.min(
                0,
                Math.max(-this._contentHeight + this._height, this._position[1])
            );
        }

        this.data.cursor[0] += (this._cursor[0] - this.data.cursor[0]) * 0.5;
        this.data.cursor[1] += (this._cursor[1] - this.data.cursor[1]) * 0.5;

        this.data.position[0] +=
            (this.data.offset * this._contentWidth +
                this._position[0] -
                this.data.position[0]) *
            1;

        const loopWidth = this._scrollWidth || this._contentWidth || 0;

        let wrappedPosition = this.data.position[0];

        if (this.data.loop && loopWidth > 0) {
            wrappedPosition = this.data.position[0] % loopWidth;

            if (wrappedPosition > 0) {
                wrappedPosition -= loopWidth;
            }
        }

        // Depth / perspective params (overridable per-instance via attributes; defaults preserve original behavior)
        const _depthFalloff = 1.5;//this.el.hasAttribute('data-depth-falloff') ? Number(this.el.getAttribute('data-depth-falloff')) : 1.5;
        const _depthMinScale = 0.1;//this.el.hasAttribute('data-depth-min-scale') ? Number(this.el.getAttribute('data-depth-min-scale')) : 0.1;
        const _depthExp = 1.2;//this.el.hasAttribute('data-depth-exp') ? Number(this.el.getAttribute('data-depth-exp')) : 1.2;
        const _depthBlur = 30;//this.el.hasAttribute('data-depth-blur') ? Number(this.el.getAttribute('data-depth-blur')) : 30;

        this.layers?.forEach((layer, i) => {
            if (!loopWidth) return;

            const viewCenter = this._width / 2;

            const baseLeft = this.data.loop
                ? layer.baseLeft
                : layer.left;

            const screenX = baseLeft + wrappedPosition;
            const cardCenter = screenX + layer.width / 2;

            const distanceFromCenter = Math.abs(cardCenter - viewCenter);

            const minScale = _depthMinScale;
            const falloff = this._width * _depthFalloff; // Smaller falloff = cards reach the far scale sooner
            let normalized = distanceFromCenter / falloff;
            normalized = Math.min(Math.max(normalized, 0), 1);
            const depth = Math.pow(normalized, _depthExp); // Lower exponent = stronger scale reduction earlier

            
            let finalScale = 1;
            let finalBlur = 0;
            let finalProjectedCenter = cardCenter;

            if (this.data.useDepth) {
                const signedDistance = cardCenter - viewCenter;
                const projectionScale = 1 - depth * (1 - minScale);
                const _depthStrength = window.innerWidth < 600 ? 1 : 2;
                const visualDepth = Math.min(depth * _depthStrength, 1);
                finalScale = 1 - visualDepth * (1 - minScale);
                const _overlap = 0.92;
                finalProjectedCenter =
                    viewCenter +
                    signedDistance * projectionScale * _overlap;
                finalBlur = visualDepth * _depthBlur;
            }

            const x =
                finalProjectedCenter -
                layer.left -
                layer.width / 2;

            const zIndex = this.data.useDepth
                ? Math.round((1 - normalized) * 100)
                : 0;

            layer.el.style.position = layer.el.style.position || 'relative';
            layer.el.style.zIndex = zIndex;

            layer.el.style.filter = this.data.useDepth
                ? `blur(${finalBlur}px)`
                : 'none';

            layer.el.style.transform =
                `translate(${x}px, ${this.data.position[1]}px) scale(${finalScale})`;
        });

        if (this.$scrollbarHandle) {
            if (this.data.loop) {
                this.$scrollbarHandle.style.transform =
                    `translateX(${((this.data.position[0] / (-this._contentWidth + this._width)) % 1) * 100}%) translateZ(0)`;
            } else {
                const bounds = this._getPositionBounds();
                const range = bounds.max - bounds.min || 1;
                const progress = (this.data.position[0] - bounds.max) / -range;

                this.$scrollbarHandle.style.transform =
                    `translateX(${progress * 100}%) translateZ(0)`;
            }
        }
    }

}

customElements.define('core-drag', CoreDrag);